import styles from './RequiredMark.module.css';

/** The " *" after a required field label, in `--text-accent`; hidden from screen readers (the control carries `required`). */
export function RequiredMark() {
  return (
    <span aria-hidden="true" className={styles.mark}>
      {' '}
      *
    </span>
  );
}
